import Home from "../features/home/Home";
import Search from "../features/serach/Search";
import Profile from "../features/profile/Profile";
import ProfileEdit from "../features/profile/ProfileEdit";
import ProfileFollowList from "../features/profile/ProfileFollowList";
import MenuList from "../features/menu/MenuList";
import Page404 from "../features/page404/Page404";
import AddRecord from "../features/record/AddRecord";
import CreateRecord from "../features/record/CreateRecord";
import RecordBoard from "../features/record/RecordBoard";
import CreateMenu from "../features/menu/CreateMenu";
import MenuCategory from "../features/menu/MenuCategory";

export const homeRoutes = [
  // /home　配下のルーティング設定
  {
    path: "/",
    exact: true,
    children: <Home />,
  },
  {
    path: "/search",
    exact: false,
    children: <Search />,
  },
  {
    path: "/profile",
    exact: true,
    children: <Profile />,
  },
  {
    path: "/profile/follow",
    exact: true,
    children: <ProfileFollowList />,
  },
  {
    path: "/profile/edit",
    exact: false,
    children: <ProfileEdit />,
  },
  {
    path: "/add/record",
    exact: false,
    children: <AddRecord />,
  },
  {
    path: "/create/record",
    exact: false,
    children: <CreateRecord />,
  },
  {
    path: "/create/menu",
    exact: false,
    children: <CreateMenu />,
  },
  {
    path: "/record/board",
    exact: false,
    children: <RecordBoard />,
  },
  {
    path: "/menu/list",
    exact: false,
    children: <MenuList />,
  },
  {
    path: "/menu/category",
    exact: false,
    children: <MenuCategory />,
  },
  {
    path: "*",
    exact: false,
    children: <Page404 />,
  },
];
